import ReactPlayer from 'react-player'
import styles from './css/movie.module.css'

export default function Movie(props) {
    return (
        <div className={styles.playerwrapper}>
            <ReactPlayer className={styles.reactplayer} url={props.url} width={props.width} height={props.height} muted={true} playing={true}/>
        </div>
    );
}